<template>
  <div>
    <v-layout>
      <v-data-table
        :key="key"
        dense
        :headers="headers"
        :items="monitor_history"
        item-key="id"
        class="elevation-1"
        :loading="loading"
        :options.sync="options"
        hide-default-footer
      >
        <template v-slot:[`item.created`]="{ item }">
          <div>
            {{ item.created }}<br />
            <span class="pr-3 text--secondary">{{
              getTimeAgo(item.created)
            }}</span>
          </div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            v-if="selectedMatch === item.acquisition_id"
            @click="removeMatch()"
            :disabled="match_loading"
            outlined
            small
            color="primary"
          >
            Remove
          </v-btn>
          <v-btn
            v-else
            @click="viewMatch(item)"
            :disabled="match_loading"
            outlined
            small
            color="primary"
          >
            View
          </v-btn>
        </template>

        <template v-slot:footer>
          <div><v-divider></v-divider></div>
          <v-layout justify-center>
            <paging-comp
              :paging_id="page_token"
              :has_more="has_more"
              @next_page="$emit('next_page', { last_id: $event.last_id })"
              @prev_page="$emit('prev_page', { first_id: $event.first_id })"
              ref="pagingComp"
            ></paging-comp>
          </v-layout>
        </template>
      </v-data-table>
    </v-layout>
  </div>
</template>

<style scoped>
.value-pointer {
  cursor: pointer;
}
</style>

<script>
import PagingComp from "@/components/shared/Paging.vue";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  props: [
    "monitor_history",
    "has_more",
    "page_token",
    "loading",
    "match_loading",
  ],
  components: {
    PagingComp,
  },
  data() {
    return {
      options: {},
      key: 0,
      selectedMatch: null,
    };
  },
  computed: {
    headers() {
      return [
        { text: "Date", value: "created" },
        { text: "Acquisitition ID", value: "acquisition_id", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ];
    },
    ...mapGetters(["user_details", "account_details"]),
  },
  watch: {
    options: {
      handler() {
        if (this.options.sortDesc.length > 0) {
          console.log(this.options.sortDesc[0]);
          var sort = this.options.sortDesc[0] ? "desc" : "asc";
          console.log(sort);
          if (sort !== (this.$route.query.sort || "desc")) {
            this.$router
              .push({
                query: {
                  sort: sort,
                },
              })
              .catch(() => {
                // catch redundant path error
              });
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    removeMatch() {
      this.key += 1;
      this.selectedMatch = null;
      this.$emit("remove_match");
    },
    viewMatch(item) {
      this.key += 1;
      this.$emit("view_match", item);
      this.selectedMatch = item.acquisition_id;
    },

    getTimeAgo(datetime) {
      return moment(datetime).fromNow();
    },

    applyFilters(start_date, end_date, filters, named_only) {
      // reset paging and push query params to router
      this.$refs.pagingComp.refreshPaging();
      this.$router
        .push({
          query: {
            start_date: start_date,
            end_date: end_date,
            filters: filters,
            named_only: named_only,
          },
        })
        .catch(() => {
          // catch redundant path error
        });
    },
  },
};
</script>
